import React, { useState } from 'react';
import styled from 'styled-components';
import Modal from '../../components/Modal';
import PropTypes from 'prop-types';

function FormSeleccionarIngreso(props) {
    const {
        periodoL,
        datos
    } = props;

    const tipos = [
        {
            value: 'DEPOSITOS',
            label: 'DEPOSITOS'
        },
        {
            value: 'NOTAS DE CREDITO',
            label: 'NOTAS DE CREDITO'
        }
    ];

    const tiposProduccion = [
        {
            value: 'DEPOSITOS',
            label: 'DEPOSITOS'
        },
        {
            value: 'DEPOSITOSREC',
            label: 'DEPOSITOS DE RECIBOS'
        },
        {
            value: 'NOTAS DE CREDITO',
            label: 'NOTAS DE CREDITO'
        }
    ];
    
    const [id, setId] = useState("");
    const [idTE, setIdTE] = useState("");

    const handleChangeTE = e => {
        setIdTE(e.target.value);
    }
    
    const handleChange = e => {
        localStorage.setItem('id_periodo', e.target.value);
        setId(e.target.value);
    }
    const [estadoModal, cambiarEstadoModal] = useState(true);
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    return (
        <div className='container'>
            <Modal
                estado={estadoModal}
                cambiarEstado={cambiarEstadoModal}
                titulo="Seleccionar Ingreso"
                botonCerrar="false"
            >
                {datos.agricola === 'S' &&
                    <div className="form-floating mb-3">
                        <select className="form-select" id="tipo" name="tipo"
                        value={idTE} onChange={handleChangeTE} autoFocus >
                        <option selected>Seleccionar...</option>
                        {tiposProduccion.map(
                            tipo => <option key={tipo.value} value={tipo.value}
                            >{tipo.label}
                            </option>)
                        }
                        </select>
                        <label className='form-label' htmlFor="mes">Ingreso</label>
                    </div>
                }
                {datos.agricola === 'N' &&
                    <div className="form-floating mb-3">
                        <select className="form-select" id="tipo" name="tipo"
                        value={idTE} onChange={handleChangeTE} autoFocus >
                        <option selected>Seleccionar...</option>
                        {tipos.map(
                            tipo => <option key={tipo.value} value={tipo.value}
                            >{tipo.label}
                            </option>)
                        }
                        </select>
                        <label className='form-label' htmlFor="mes">Ingreso</label>
                    </div>
                }
                {periodoL && idTE != '' &&
                    <div className="form-floating mb-3">
                        <select className="form-select" id="periodo"
                            value={id} onChange={handleChange} >
                            <option selected>Seleccionar...</option>
                            {periodoL.map(mes =>
                                <option key={mes.value} value={mes.value}>{mes.label}</option>)
                            }

                        </select>
                        <label className='form-label' htmlfor="periodo">Periodo</label>
                    </div>
                }
                <br />
                <Contenido>
                    {periodoL.length > 0 && idTE === 'DEPOSITOS' &&
                        (id &&
                        <a
                        href={`/#/bancos/${id_emp[5]}/deposito/${id}`}
                        className='btn mr-2 mb-3 btn-primary'
                        >
                            Seleccionar
                        </a>
                        )
                    }
                    {periodoL.length > 0 && idTE === 'NOTAS DE CREDITO' &&
                        (id &&
                        <a
                            href={`/#/bancos/${id_emp[5]}/nota_credito/${id}`}
                            className='btn mr-2 mb-3 btn-primary'
                        >
                            Seleccionar
                        </a>
                        )
                        
                    }
                    {periodoL.length > 0 && idTE === 'DEPOSITOSREC' &&
                        (id &&
                        <a
                        href={`/#/bancos/${id_emp[5]}/deposito_recibo/${id}`}
                        className='btn mr-2 mb-3 btn-primary'
                        >
                            Seleccionar
                        </a>
                        )
                    }
                </Contenido>
            </Modal>
        </div>
    );

}
FormSeleccionarIngreso.propTypes = {
    periodoL: PropTypes.string.isRequired,
};

export default (FormSeleccionarIngreso);

const Contenido = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;

`;